import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'
import { createStore, applyMiddleware, compose } from 'redux'
import rootReducer from './reducers'
import thunkMiddleware from 'redux-thunk'
import './index.css';
import App from './components/App';
import registerServiceWorker from './registerServiceWorker';
import { BrowserRouter } from 'react-router-dom'
import { version } from '../package.json'
import { loadStripe } from '@stripe/stripe-js';

global.serverUrl = 'http://localhost:5000';
global.key = 'pk_test_WPxcjB02adLl31avR49jVgx3';
global.stravaUrl='https://www.strava.com/oauth/authorize?client_id=22661&redirect_uri=http://localhost:3000/editor&approval_prompt=auto&response_type=code&scope=read_all,activity:read_all,profile:read_all';
global.version = version

if (process.env.NODE_ENV === "production") {
    //Remove console outputs
    if(!window.console) window.console = {};
    var methods = ["log", "debug", "warn", "info"];
    for(var i=0;i<methods.length;i++){
        console[methods[i]] = function(){};
    }

    global.serverUrl = 'https://cartorion-backend.onrender.com';
    global.key = 'pk_live_LkkOF3Utevlz1ndVYj7PGN4T';
    global.stravaUrl='https://www.strava.com/oauth/authorize?client_id=22661&redirect_uri=https://www.cartorion.com/editor&approval_prompt=auto&response_type=code&scope=read_all,activity:read_all,profile:read_all';
}

global.stripePromise = loadStripe(global.key);
//Needed for Redux devtools
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(rootReducer, composeEnhancers(
    applyMiddleware(
        thunkMiddleware
    )
))

//Export store to be accesible from anywhere
export default store;

ReactDOM.render(
    <Provider store={store}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </Provider>
, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js